//
//
//
//
import articleBase from '../articleBase';
export default {
  name: 'study',
  components: {
    articleBase: articleBase
  }
};